module.exports = __webpack_public_path__ + "img/Neo-Tips-Pic5.99d4448a.png";